import { render, staticRenderFns } from "./Autenticacao.vue?vue&type=template&id=c56064d8"
import script from "./Autenticacao.vue?vue&type=script&lang=ts"
export * from "./Autenticacao.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports